import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Bell, Tag, Package, CheckCheck } from "lucide-react";
import { EmptyState } from "@/components/common";
import { api } from "@/lib/api";

export default function Notifications() {
  const nav = useNavigate();
  const [list, setList] = useState(null);
  const load = () => api.get("/notifications").then((r) => setList(r.data)).catch(() => setList([]));
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post("/notifications/read"); load(); };

  return (
    <div className="min-h-screen bg-surface max-w-[520px] mx-auto pb-10">
      <div className="sticky top-0 z-40 bg-white border-b border-border px-3 py-3 flex items-center gap-2">
        <button onClick={() => nav(-1)} className="w-9 h-9 flex items-center justify-center tap"><ArrowLeft size={22} /></button>
        <h1 className="font-display font-bold text-lg flex-1">Notifications</h1>
        <button onClick={markAll} className="text-coral font-semibold text-sm flex items-center gap-1" data-testid="mark-all-read"><CheckCheck size={16} /> Mark all read</button>
      </div>
      <div className="px-4 py-4 space-y-2">
        {!list ? [0, 1, 2].map((i) => <div key={i} className="skel h-16 rounded-2xl" />) :
          list.length === 0 ? <EmptyState icon={Bell} title="No notifications" subtitle="Order updates and offers will appear here." /> :
            list.map((n) => (
              <div key={n.id} className={`rounded-2xl border p-3.5 flex gap-3 ${n.read ? "bg-white border-border" : "bg-coral-light border-coral/30"}`} data-testid={`notif-${n.id}`}>
                <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center shrink-0">{n.type === "offer" ? <Tag size={18} className="text-coral" /> : <Package size={18} className="text-coral" />}</div>
                <div className="min-w-0"><div className="font-bold text-sm text-ink">{n.title}</div><div className="text-xs text-ink-600">{n.body}</div><div className="text-[10px] text-ink-600 mt-1">{new Date(n.created_at).toLocaleString()}</div></div>
              </div>
            ))}
      </div>
    </div>
  );
}
